import { GeoPoint, Timestamp } from "firebase/firestore";
import { GeoPointProps } from "../types/geoPoint.type";

export const fromFirestore = <T extends Record<string, unknown>>(document: T) => {
    Object.entries(document).forEach(([key, value]) => {
        if (typeof value !== 'object' || value === null) return;
        if (value instanceof Timestamp) {
            // @ts-ignore
            document[key] = value.toDate().toISOString();
            return;
        }
        if (value instanceof GeoPoint) {
            // @ts-ignore
            // document[key] = { latitude: value._lat, longitude: value._long } as GeoPointProps;
            // document[key] = value.toJSON() as GeoPointProps;
            document[key] = new GeoPointProps(value.latitude, value.longitude).toJSON();
            return;
        }
        // @ts-ignore
        document[key] = fromFirestore(value);
    });
    return document as T;
};

export const toFirestore = <T extends Record<string, unknown>>(document: T) => {
    Object.entries(document).forEach(([key, value]) => {
        if (typeof value !== 'object' || value === null) return;
        // if ((/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(value.toString()))) {
        if (key === 'createdAt' || key === 'updatedAt' || key === 'date' || key === 'startClass' || key === 'startYear' || key === 'inscriptions') {
            if (value instanceof Timestamp || (value && typeof value === 'object' && '_methodName' in value)) return;
            try {
                let dateValue: Date | null = null;
                if (value instanceof Date) {
                    dateValue = value;
                } else if (typeof value === 'string' || typeof value === 'number') {
                    dateValue = new Date(value);
                }
                if (dateValue && !isNaN(dateValue.getTime())) {
                    document = Object.assign(document, { [key]: Timestamp.fromDate(dateValue) });
                }
            } catch (error) {
                console.error("Error in toFirestore.", `key: ${key}`, `value: ${value}`);
            }
            return;
        }
        // if (value.toString().indexOf('latitude:') > -1 && value.toString().indexOf('longitude:') > -1) {
        if (key === 'geoLocation' || key === 'location') {
            // if (value instanceof {latitude: number}) {
            // if (value instanceof GeoPointProps) {
            // @ts-ignore
            try {
                const jsonValue = value as { latitude: number; longitude: number };
                // document[key] = new GeoPoint(jsonValue.latitude, jsonValue.longitude);
                document = Object.assign(document, { [key]: new GeoPoint(jsonValue.latitude, jsonValue.longitude) });
            } catch (error) {
                console.error("Error in toFirestore.", `key: ${key}`, `value: ${value}`);
            }
            // GeoPointProps{};
            return;
        }
        // @ts-ignore
        document[key] = toFirestore(value);
    });
    return document as T;
};

// Clean undefined values recursively so updateDoc never throws Unsupported field value: undefined
export const cleanData = (obj: any): any => {
    if (obj === null || typeof obj !== "object") return obj;
    if (obj instanceof Date || obj instanceof Timestamp || ('_methodName' in obj)) return obj;
    if (Array.isArray(obj)) return obj.map(cleanData);
    const result: any = {};
    Object.keys(obj).forEach((key) => {
        if (obj[key] !== undefined) {
            result[key] = cleanData(obj[key]);
        }
    });
    return result;
};